import {fuzzyMatch} from '@wandb/weave/common/util/fuzzyMatch';
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {ApolloQueryResult} from 'apollo-client';
import React, {useState} from 'react';

import {ProjectArtifactsQuery} from '../../generated/graphql';
import {usePaginate} from '../../util/usePaginate';
import * as S from './ArtifactSidebar.styles';
import {ArtifactSidebarPaginate} from './ArtifactSidebarSequence';
import {ArtifactSequence} from './MetadataQueryResultsSequences';
import {ARTIFACTS_PER_TYPE, ArtifactSequenceSidebar} from './utils';

interface ArtifactTypeProps {
  typeName: string;
  sequences: {[sequenceName: string]: ArtifactSequenceSidebar};
  projectName: string;
  entityName: string;
  artifactCommitHash?: string;
  artifactTab?: string;
  filePath?: string;
  refetchProjectArtifacts: () => Promise<
    ApolloQueryResult<ProjectArtifactsQuery>
  >;
  artifactFilterResults: string;
  artifactCollectionName?: string;
}

// Component to display Artifact Types
export const ArtifactType: React.FC<ArtifactTypeProps> = props => {
  let filteredMap: {[sequenceName: string]: ArtifactSequenceSidebar} =
    props.sequences;

  if (props.artifactFilterResults !== '') {
    const filteredSequences = fuzzyMatch(
      Object.keys(props.sequences),
      props.artifactFilterResults
    );

    filteredMap = Object.keys(props.sequences)
      .filter(key => filteredSequences.includes(key))
      .reduce(
        (obj, key) => {
          obj[key] = props.sequences[key];
          return obj;
        },
        {} as {[sequenceName: string]: ArtifactSequenceSidebar}
      );
  }

  const sequenceArray = Object.values(filteredMap);
  const {
    totalPages,
    hasNextPage,
    hasPreviousPage,
    setPage,
    total,
    page,
    itemsPage,
  } = usePaginate(sequenceArray, ARTIFACTS_PER_TYPE);
  const [active, setActive] = useState(true);
  const iconToggle = active ? 'chevron-down' : 'chevron-next';
  return (
    <Tailwind>
      {itemsPage.length > 0 && (
        <S.ArtifactTypeContainer>
          <S.ArtifactTypeBox onClick={() => setActive(s => !s)}>
            <Icon name={iconToggle} />
            <span className="artifact-type-title">{props.typeName}</span>
          </S.ArtifactTypeBox>
          {active && (
            <div className="ml-2 border-l border-moon-300 pl-1">
              {itemsPage.map(sequence => (
                <ArtifactSequence
                  key={sequence.name}
                  {...props}
                  artifactTypeName={props.typeName}
                  artifactSequence={sequence}
                />
              ))}
              {totalPages > 0 && (
                <S.ArtifactSidebarTypePaginate>
                  <ArtifactSidebarPaginate
                    size="tiny"
                    perPage={ARTIFACTS_PER_TYPE}
                    page={page}
                    total={total}
                    pageInfo={{hasNextPage, hasPreviousPage}}
                    onNextClick={() => setPage(s => s + 1)}
                    onPreviousClick={() => setPage(s => s - 1)}
                  />
                </S.ArtifactSidebarTypePaginate>
              )}
            </div>
          )}
        </S.ArtifactTypeContainer>
      )}
    </Tailwind>
  );
};
